/**
 * REST sharing endpoints — DOC1 §7.13, §11.1.
 *
 * @deprecated Phase 2 — QR-token sharing is retired in favour of mobile-number-based
 * member addition (POST /members). Both routes below return `410 Gone` with error code
 * `SHARING_DEPRECATED`. Schemas remain so existing clients parse the 410 body correctly.
 * This module will be removed after one full release following the Phase 2 rollout.
 *
 *   POST /devices/{id}/share        — (deprecated) owner creates a sharing QR
 *   POST /devices/share/claim       — (deprecated) recipient claims the QR
 *
 * Permissions shape — RESOLVED at T025 (DOC4 §6 open item closed).
 */
import { z } from 'zod';
import { Iso8601Schema } from '../common/timestamp.js';
import { DeviceSchema } from './devices.js';
/** Fixed-shape share permissions (T025 resolution). */
export const SharePermissionsSchema = z.object({
    /** May send commands to the device. */
    control: z.boolean(),
    /** May change device configuration. */
    configure: z.boolean(),
    /** May re-share the device (requires can_reshare). */
    share: z.boolean(),
});
// ── POST /devices/{id}/share ───────────────────────────────────────────────
/** @deprecated Returns 410 Gone. Use POST /members instead. */
export const ShareCreateBody = z.object({
    canReshare: z.boolean(),
    permissions: SharePermissionsSchema,
    /** Optional expiry override — default is server-side (e.g. 24h). */
    expiresAt: Iso8601Schema.optional(),
});
export const ShareCreateResponse = z.object({
    qrToken: z.string().min(1),
    expiresAt: Iso8601Schema,
});
// ── POST /devices/share/claim ──────────────────────────────────────────────
/** @deprecated Returns 410 Gone. Use POST /members instead. */
export const ShareClaimBody = z.object({
    qrToken: z.string().min(1),
});
export const ShareClaimResponse = z.object({
    device: DeviceSchema,
    permissions: SharePermissionsSchema,
    canReshare: z.boolean(),
});
//# sourceMappingURL=sharing.js.map